// assets
import { IconPackages } from '@tabler/icons';
import mchChild from './MchChild';

// constant
const icons = { IconPackages };

const machinesCol = {
    id: `machinesCol-${Math.random()}`,
    title: 'Machines',
    type: 'collapse',
    // url: `/dashboard/default`,
    icon: icons.IconPackages,
    breadcrumbs: false,
    children: mchChild,
    role: process.env.REACT_APP_RL_MCHCOL
};

export default machinesCol;
